// Static demo content for Michele Rago's portfolio.

export const PROJECTS_DATA = [
  {
    id: 'aperture',
    index: '01',
    title: 'Aperture',
    category: 'Mobile · Fintech',
    year: '2025',
    description:
      'A radically calm banking experience. Rethinking how people feel about money through restraint, motion and tactile clarity.',
    tags: ['Product Design', 'iOS', 'Design System'],
    type: 'photo',
    image:
      'https://images.pexels.com/photos/12973919/pexels-photo-12973919.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400',
    accent: '#e8e6e1',
  },
  {
    id: 'monolith',
    index: '02',
    title: 'Monolith',
    category: 'Web · SaaS Platform',
    year: '2024',
    description:
      'An analytics workspace for design teams. Dense data made effortless with a spatial, keyboard-first interface.',
    tags: ['UX Strategy', 'Web App', 'Data Viz'],
    type: 'photo',
    image:
      'https://images.pexels.com/photos/35052818/pexels-photo-35052818.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400',
    accent: '#dcd7cf',
  },
  {
    id: 'ostro',
    index: '03',
    title: 'Ostro',
    category: 'Brand · Immersive Web',
    year: '2024',
    description:
      'A kinetic identity and site for an architecture studio. Type in motion, spatial galleries and slow deliberate reveals.',
    tags: ['Art Direction', 'Motion', 'WebGL'],
    type: 'text',
    gradient: 'linear-gradient(135deg, #1c1c1e 0%, #0a0a0a 60%, #2a2a2c 100%)',
    accent: '#f4f2ee',
  },
  {
    id: 'halcyon',
    index: '04',
    title: 'Halcyon',
    category: 'Product · Wellness',
    year: '2023',
    description:
      'A meditation companion built around breath. Micro-interactions tuned to the second, guiding without instructing.',
    tags: ['Product Design', 'Prototyping', 'Sound'],
    type: 'text',
    gradient: 'linear-gradient(135deg, #101013 0%, #060606 55%, #232326 100%)',
    accent: '#eceae6',
  },
];

export const MANIFESTO = [
  {
    n: '01',
    title: 'Clarity over decoration.',
    body: 'Every pixel earns its place. I design interfaces that disappear so the work — and the people using it — can take center stage.',
  },
  {
    n: '02',
    title: 'Motion with meaning.',
    body: 'Animation is not garnish. It carries intent, guides attention and gives digital products a sense of physical weight and grace.',
  },
  {
    n: '03',
    title: 'Systems that scale.',
    body: 'From a single button to an entire product language, I build considered systems that let teams move fast without losing soul.',
  },
];

export const SERVICES = [
  {
    id: 'product',
    title: 'Product Design',
    tag: 'END TO END',
    body: 'From messy problem to shipped product. Discovery, flows, high-fidelity UI and hand-off.',
  },
  {
    id: 'systems',
    title: 'Design Systems',
    tag: 'SCALE',
    body: 'Component libraries, tokens and documentation that keep teams fast and consistent.',
  },
  {
    id: 'motion',
    title: 'Motion & Prototyping',
    tag: 'FEEL',
    body: 'Interaction design and prototypes that prove the feel before a line of code is written.',
  },
  {
    id: 'brand',
    title: 'Brand & Art Direction',
    tag: 'IDENTITY',
    body: 'Visual identities and immersive web experiences with a distinct point of view.',
  },
];

export const STATS = [
  { value: '8+', label: 'Years designing' },
  { value: '60+', label: 'Products shipped' },
  { value: '12', label: 'Awards won' },
  { value: '∞', label: 'Cups of espresso' },
];

export const WHY_2026 = [
  {
    n: '01',
    icon: 'Globe',
    title: 'La tua vetrina è aperta 24/7',
    body: 'Nel 2026 il primo contatto con un cliente avviene online. Un sito curato lavora per te giorno e notte, presentando chi sei anche quando dormi.',
  },
  {
    n: '02',
    icon: 'ShieldCheck',
    title: 'Credibilità e fiducia immediate',
    body: 'Il 75% delle persone giudica la serietà di un brand dal suo sito. Un design premium comunica competenza prima ancora di leggere una parola.',
  },
  {
    n: '03',
    icon: 'Search',
    title: 'Ti trovano su Google, non i competitor',
    body: 'Senza un sito indicizzato sei invisibile. Con SEO e contenuti giusti intercetti chi sta già cercando esattamente ciò che offri.',
  },
  {
    n: '04',
    icon: 'Smartphone',
    title: 'Un\u2019esperienza che converte',
    body: 'Social e marketplace impongono le loro regole. Il tuo sito è l\u2019unico spazio che controlli al 100%, ottimizzato per trasformare visite in clienti.',
  },
  {
    n: '05',
    icon: 'TrendingUp',
    title: 'Un investimento, non un costo',
    body: 'A differenza della pubblicità che smette quando smetti di pagare, un sito ben fatto continua a generare valore e contatti nel tempo.',
  },
  {
    n: '06',
    icon: 'Sparkles',
    title: 'Ti distingui dalla massa',
    body: 'Template anonimi ce ne sono ovunque. Un\u2019identità digitale su misura, con motion e dettagli curati, rende il tuo brand memorabile.',
  },
];

export const PERSONAL_BIO =
  "Sono Michele, un web designer ormai da quasi 10 anni. Amici e conoscenti mi descrivono come una persona tranquilla e serena, paziente e con un grande senso dell'umorismo e dell'autoironia. Le mie passioni oltre al web design sono il basket, lo snowboard, la lettura in particolare i libri sul buddismo e di storia.";

export const DESIGN_STYLES = [
  {
    id: 'minimalist',
    name: 'Minimalist',
    tag: 'Less, but better',
    body: 'Spazio, silenzio, gerarchia. Ogni elemento guadagna il suo posto. Il vuoto diventa protagonista e ogni dettaglio respira.',
    variant: 'minimal',
  },
  {
    id: 'brutalism',
    name: 'Brutalism',
    tag: 'Raw & unapologetic',
    body: 'Tipografia gigantesca, bordi netti, contrasti aggressivi. Rifiuta la decorazione per abbracciare una schiettezza quasi materica.',
    variant: 'brutal',
  },
  {
    id: 'editorial',
    name: 'Editorial',
    tag: 'Type-first storytelling',
    body: 'Ispirato alle riviste di design: griglie asimmetriche, serif eleganti, capolettera e ritmo di lettura da magazine premium.',
    variant: 'editorial',
  },
  {
    id: 'neumorphism',
    name: 'Neumorphism',
    tag: 'Soft & tactile',
    body: 'Superfici morbide, ombre doppie, componenti che sembrano scolpiti nel materiale. Un ritorno gentile al fisico.',
    variant: 'neumorph',
  },
  {
    id: 'glassmorphism',
    name: 'Glassmorphism',
    tag: 'Frosted depth',
    body: 'Vetri sfumati, backdrop-blur, layer luminosi. Profondità e senso di spazialità come nel design Apple più recente.',
    variant: 'glass',
  },
  {
    id: 'maximalist',
    name: 'Maximalist',
    tag: 'More is more',
    body: 'Colore, motion, texture, personalità. Un\u2019esplosione controllata di espressione visiva per brand che vogliono farsi notare.',
    variant: 'max',
  },
];

export const FAQ = [
  {
    q: 'Quanto costa realizzare un sito web professionale?',
    a: 'Dipende dagli obiettivi: una landing page one-page parte da cifre contenute, mentre un sito completo con più sezioni, contenuti e animazioni su misura richiede un investimento maggiore. Dopo una breve call ti fornisco un preventivo chiaro e senza sorprese, basato su ciò che serve davvero al tuo progetto.',
  },
  {
    q: 'Quanto tempo serve per avere il sito online?',
    a: 'Una landing page curata richiede in media 2\u20133 settimane; un sito multi-pagina 4\u20136 settimane. I tempi dipendono dalla rapidità con cui riceviamo testi e materiali. Ti condivido una timeline precisa già in fase di proposta.',
  },
  {
    q: 'Il sito sarà ottimizzato per smartphone e tablet?',
    a: 'Assolutamente sì. Progetto con approccio mobile-first: oltre il 60% del traffico arriva da smartphone, quindi ogni sito è testato per essere impeccabile e velocissimo su qualsiasi dispositivo.',
  },
  {
    q: 'Comparirò su Google?',
    a: 'Ogni sito viene costruito con le basi SEO tecniche corrette: struttura semantica, performance, meta tag e contenuti ottimizzati. Questo ti dà le fondamenta per posizionarti; possiamo poi lavorare su una strategia di contenuti per scalare le ricerche più competitive.',
  },
  {
    q: 'Potrò aggiornare i contenuti da solo?',
    a: 'Sì. Posso integrare un CMS semplice e intuitivo che ti permette di modificare testi, immagini e progetti in autonomia, senza toccare il codice. In alternativa offro un servizio di manutenzione dedicato.',
  },
  {
    q: 'Cosa succede dopo la pubblicazione?',
    a: 'Non ti lascio solo. Offro assistenza post-lancio, aggiornamenti e monitoraggio delle performance. Un sito è un prodotto vivo: lo facciamo evolvere insieme man mano che il tuo business cresce.',
  },
  {
    q: 'Ho già un sito ma è datato. Posso rifarlo?',
    a: 'Certo, il restyling è uno dei servizi più richiesti. Analizzo il sito attuale, ne conservo i punti di forza (e la SEO acquisita) e lo trasformo in un\u2019esperienza moderna, veloce e allineata al tuo brand.',
  },
];

